<template>
  <div ref="dropdown" :class="buttonWarpperClass">
    <!-- Dropdown Toggle Button -->
    <!-- icon first, like the other header pills (Messages, Notifications) -->
    <button type="button" :class="buttonClass" @click="toggleDropdown">
      <div :class="buttonIconClass">
        <img src="../../assets/images/create-quote-icon.png" alt="Create Quote Icon"
          class="w-full h-full object-contain group-hover:hidden">
        <img src="../../assets/images/create-quote-icon-white.png" alt="Create Quote Icon"
          class="w-full h-full object-contain hidden group-hover:!block">
      </div>
      <span :class="buttonTextClass">Create Quote</span>
    </button>

    <!-- Dropdown Menu -->
    <div v-if="isOpen" :class="dropdownListClass">
      <ul class="list-inline mb-0 p-2 max-h-60 ">
        <li v-for="(item, index) in itemList" :key="index" :class="dropdownListLIClass">
          <a @click="actionClicked(item.id)" :class="dropdownListAnchorClass">{{ item.title }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { array, object } from 'yup';

export default {
  props: {
    buttonWarpperClass: {
      type: String,
      default: '',
    },
    buttonClass: {
      type: String,
      default: '',
    },
    buttonIconClass: {
      type: String,
      default: '',
    },
    buttonTextClass: {
      type: String,
      default: '',
    },
    dropdownListClass: {
      type: String,
      default: '',
    },
    dropdownListLIClass: {
      type: String,
      default: '',
    },
    dropdownListAnchorClass: {
      type: String,
      default: '',
    },
    buttonStyle: {
      type: object,
      default: '',
    },
    itemList: {
      type: array,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    actionClicked(item){
      // the pick happens inside the dropdown, so the outside-click handler never closes it (Replacement Quote now navigates instead of opening a modal)
      this.isOpen = false;
      this.$emit("event", "actionClicked",item);
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.dropdown;
      if (dropdown && !dropdown.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
};
</script>